import { RootState } from '@checkout/state';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Minicart } from './../components/container';
import ConnectedIntlProvider from './../wrappers/ConnectedIntlProvider';
import ErrorBoundary from './../wrappers/ErrorBoundary';

interface IOwnProps {
  store: Store<RootState>;
  persistor: Persistor;
  showLabel?: boolean;
  cartLabel?: string;
  intlData?: IntlProvider.Props;
}

const MinicartApp: React.SFC<IOwnProps> = ({ store, persistor, cartLabel, showLabel, intlData }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedIntlProvider {...intlData} >
        <ErrorBoundary>
          <Minicart showLabel={showLabel} cartLabel={cartLabel} />
        </ErrorBoundary>
      </ConnectedIntlProvider>
    </PersistGate>
  </Provider>
);

export default MinicartApp;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/apps/MinicartApp.tsx